import { lazy, Suspense } from "react";

// Lazy load deck components - each becomes its own chunk
const decks: Record<string, React.LazyExoticComponent<React.ComponentType>> = {
  brand: lazy(() => import("./decks/brand")),
  concordium: lazy(() => import("./decks/concordium")),
  investor: lazy(() => import("./decks/investor")),
};

// Only these decks show in the 404 list (others are unlisted but still routable)
const publicDecks = ["brand"];

function LoadingFallback() {
  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: "#1a1a1a", color: "#93a1a1" }}
    >
      <div className="text-center">
        <div className="text-2xl mb-2">Loading slides...</div>
        <div className="text-sm opacity-50">Preparing your deck</div>
      </div>
    </div>
  );
}

function DeckNotFound() {
  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: "#1a1a1a", color: "#93a1a1" }}
    >
      <div className="text-center">
        <div className="text-2xl mb-4">Deck not found</div>
        <div className="text-sm opacity-70 mb-6">Available decks:</div>
        <div className="flex flex-col gap-2">
          {publicDecks.map((deck) => (
            <a
              key={deck}
              href={`/slides/${deck}`}
              className="px-4 py-2 rounded-lg hover:bg-white/10 transition-colors"
              style={{ color: "#2aa198" }}
            >
              /slides/{deck}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export function SlidesRouter() {
  // Get deck name from path: /slides/investor -> "investor"
  const path = window.location.pathname;
  const deckName = path.replace(/^\/slides\/?/, "").split("/")[0] || "brand";

  const DeckComponent = decks[deckName];

  if (!DeckComponent) {
    return <DeckNotFound />;
  }

  return (
    <Suspense fallback={<LoadingFallback />}>
      <DeckComponent />
    </Suspense>
  );
}
